import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider,
  Drawer,
  List,
  makeStyles,
  TextField,
  Typography,
  Tooltip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormControlLabel,
  AppBar,
  Tabs,
  Tab,
  Box,
  Menu,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { fetchEntitiesService as fetchProceduresService } from "../../redux/slices/procedureDropdownSlice.js";
import { blue } from "@material-ui/core/colors";
import Controls from "../../components/controls";
import { debounce, isEmpty } from "lodash";
import Popup from "../Popup";
import IconButton from "../controls/IconButton";
import ScrollBar from "react-perfect-scrollbar";
import SearchIcon from "@material-ui/icons/Search";
import Iconify from "../Iconify";
import Api from "../../lib/api";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import reactStringReplace from "react-string-replace";
import AddIcon from "@material-ui/icons/Add";
import MyTemplatesForm from "./MyTemplatesForm.js";
import EditIcon from "@material-ui/icons/Edit";
import ConfirmDialog from "../ConfirmDialog.js";
import CRMUtils from "../../utils/index.js";

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  drawer: {
    maxHeight: 600,
    "& .MuiDrawer-paper": {
      position: "initial",
    },
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    border: "1px solid #eeeeee",
    borderRadius: "10px",
    padding: 10,
    "&.MuiDrawer-paperAnchorDockedLeft": {
      borderRight: "1px solid rgba(0, 0, 0, 0.04)",
    },
    width: drawerWidth,
  },
  input: {
    color: "#EEEFF1",
    "&.Mui-focused": {
      color: "#EEEFF1",
    },
  },
  select: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  root: {
    "& .MuiFormControl-root": {
      width: "80%",
      margin: theme.spacing(1),
    },
  },
  detailContainer: {
    margin: "1px 5px",
  },
  detailTitle: {
    color: "#364d93",
    fontWeight: 500,
    fontSize: 16,
  },
  detailText: {
    fontSize: 16,
  },
  appBar: {
    borderRadius: "10px 10px 0px 0px",
    background: "#dde9f1b3",
  },
  tabStyle: {
    minWidth: 90,
    "&.MuiTab-textColorPrimary.Mui-selected": {
      color: "#3575a1",
    },
  },
  appBarLanguages: {
    color: "rgba(0, 0, 0, 0.87)",
    background: "white",
    boxShadow: "none",
    borderRadius: "10px 10px 0px 0px",
  },
}));

// var dataSliceProceduresDropdown = {
//   stateListName: "proceduresDropdown",
//   dataUrl: {},
//   orgId: 1,

//   getFilters: {
//     include: [],
//     params: [],
//     filters: [],
//   },
//   dataList: {
//     showPageLoading: false,
//     successHandle: null,
//   },
//   dataUpdate: {
//     id: null,
//     data: null,
//     successHandle: null,
//   },
//   dataCreate: {
//     data: null,
//     successHandle: null,
//   },
//   dataDelete: {
//     id: null,
//     successHandle: null,
//   },
//   errorHandle: null,
// };

function TabPanel(props) {
  const { children, value, index, st = null, ...other } = props;

  return (
    <div
      style={st != null ? st : { width: "100%" }}
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function TemplatesSMSMMS(props) {
  const dispatch = useDispatch();
  const {
    authUser,
    send_unsuscribe_link,
    contactForEdit,
    setIsOpenDialogTemplates,
    templates,
    sendSmsMms,
    setTemplates,
    category,
  } = props;
  const [isSharing, setIsSharing] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [popupMyTemplatesForm, setPopupMyTemplatesForm] = useState(false);
  const [templateSelected, setTemplateSelected] = useState(null);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(0);
  const [templateForEdit, setTemplateForEdit] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [expandedControl, setExpandedControl] = useState({
    building: null,
    dr: null,
  });
  const [users, setUsers] = useState([]);
  const [isOpenSharePopup, setIsOpenSharePopup] = useState(false);
  const filtersApplied = useRef({ filters: {} });
  const [filters, setFilters] = useState({ filters: {} });
  var confirmDialogLoading = false;
  const [procedures, setProcedures] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [shareTo, setShareTo] = useState(null);
  const userCanViewAll = CRMUtils.userHasPermission(authUser, [
    "user_viewallsmsmmstemplates",
  ]);

  const handleLanguageTabChange = (e, value) => {
    setSelectedLanguage(value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getBuildings = async (id) => {
    const { data } = await Api.getBuildingsWithDoctors("?category_id=" + id);

    if (userCanViewAll) {
      setBuildings([...data.data]);
    } else {
      var buildings = [...data.data].filter(
        (a) => a.id == authUser.building_id
      );
      setBuildings([...buildings]);
    }
  };

  const getDoctors = async (id) => {
    const { data } = await Api.getActiveDoctors(1, "?category_id=" + id);
    setDoctors([...data.data]);
  };

  const getProcedures = async (id) => {
    const { data } = await Api.getProceduresTemplates("?category_id=" + id);
    setProcedures([...data.data]);
  };

  const procedureOptions = () => {
    let procedure = [];

    procedure = procedures.map((product) => {
      //es aqui
      return {
        id: product.id,
        title: product.name,
      };
    });

    return procedure;
  };

  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = async (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    console.log("Checkbox is now:", isChecked ? "Checked" : "Unchecked");
    try {
      if (isChecked) {
        const { data } = await Api.getProceduresTemplates(
          "?filter_active=0&category_id=" + category.id
        ); // llamada API
        setProcedures([...data.data]); // Actualiza los procedimientos con los nuevos valores Activos + Inactivos
      } else {
        const { data } = await Api.getProceduresTemplates(
          "?filter_active=1&category_id=" + category.id
        ); // Recupera los procedimientos activos
        setProcedures([...data.data]); // Actualiza los procedimientos con los valores por defecto (Solo Activos)
      }
      console.log("API Response:", response);
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const getMyUsers = async () => {
    const { data } = await Api.getMyGroupsUsers(authUser.id);

    setUsers([...data.data]);
  };

  const openMyTemplatesForm = async (item = null) => {
    if (item && item != null) {
      const { data } = await Api.getSMSMMSTemplate(item.id);
      setTemplateForEdit(data.data);
    }

    setPopupMyTemplatesForm(true);
  };

  const closeMyTemplatesForm = () => {
    setTemplateForEdit(null);
    setPopupMyTemplatesForm(false);
  };

  useEffect(() => {
    getSMSMMSTemplatesByCategory(category.id);
    getBuildings(category.id);
    getDoctors(category.id);
    // if (isEmpty(proceduresDropdown)) {
    //   dispatch(fetchProceduresService(dataSliceProceduresDropdown));
    // }
    getMyUsers();
    getProcedures(category.id);
  }, []);

  const closeTemplate = () => {
    setTemplateSelected(null);
  };

  const onChangeCheckBox = (item) => {
    var index = selectedTemplates.findIndex((a) => a.id == item.id);
    var templatesSelected = [];
    if (index == -1) {
      templatesSelected = [...selectedTemplates, item];
      setSelectedTemplates([...selectedTemplates, item]);
    } else {
      templatesSelected = selectedTemplates.filter((a) => a.id != item.id);
      setSelectedTemplates(selectedTemplates.filter((a) => a.id != item.id));
    }

    if (
      templates &&
      templatesSelected &&
      templates.length == templatesSelected.length
    ) {
      setIsSelectedAll(true);
    } else {
      setIsSelectedAll(false);
    }
  };

  const sendTemplates = async (language) => {
    var payloads = [];
    selectedTemplates.map(async (item) => {
      var bodySend =
        language == "es"
          ? item?.body_es || item.body
          : item?.body || item.body_es;

      var payload = {
        group: 0,
        attchURL: item.tempUrl ? item.tempUrl : null,
        body: bodySend,
        mediaType: item.media_type,
        category_id: 4,
      };

      payloads.push(payload);
    });
    await sendSmsMms(payloads);
  };

  const deleteTemplate = async (id) => {
    const { data } = await Api.deleteSMSMMSTemplate(id);
    setTemplates(templates.filter((a) => a.id != id));
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  const getSMSMMSTemplatesByCategory = async (id, payload = null) => {
    setIsLoading(true);
    const { data } = await Api.getSMSMMSTemplatesByCategory(id, payload);
    setIsLoading(false);
    setTemplates([...data.data]);
  };

  const onSearchChange = (value) => {
    setSearchValue(value);

    getSMSMMSTemplatesByCategory(category.id, {
      ...filtersApplied.current,
      ...{ name: value },
    });
  };

  const onClickDelete = (id) => {
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this Template?",
      subTitle: "You can't undo this operation",
      onConfirm: () => deleteTemplate(id),
    });
  };

  const debouncedSearch = useCallback(
    debounce((newValue) => onSearchChange(newValue), 800),
    []
  );

  const shareTemplates = async () => {
    var ids = selectedTemplates.map((template) => template.id);
    var payload = {
      ids: ids,
      share_to: shareTo,
    };

    setIsSharing(true);
    await Api.shareSMSMMSTemplates(payload);
    setIsSharing(false);
    setIsOpenSharePopup(false);
    setSelectedTemplates([]);
  };

  const shareToOptions = () => {
    return users.map((user) => {
      return { id: user.id, title: user.users_fname };
    });
  };

  const [selectedProcedure, setSelectedProcedure] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [selectedBuilding, setSelectedBuilding] = useState("");

  const handleFilterChange = (key, value) => {
    const filter = {
      ...filters?.filters,
      [key]: value,
    };

    var filtersToApply = {};
    Object.keys(filter).forEach((key) => {
      if (filter[key] != -1 && filter[key] != -3) {
        filtersToApply[key] = filter[key];
      }
    });

    setFilters({ ...filters, filters: filtersToApply });
    filtersApplied.current = { ...filters, filters: filtersToApply };
    getSMSMMSTemplatesByCategory(category.id, { filters: filtersToApply });
  };

  const handleProcedureChange = (event) => {
    const selectedValue = event.target.value;

    // Si selecciona "No Procedure" (-2), filtrar los que no tienen procedimiento (procedure_id = null)
    setSelectedProcedure(selectedValue == -1 ? "" : selectedValue);
    setSelectedProcedure(selectedValue == -3 ? "" : selectedValue);

    handleFilterChange(
      "procedure_id",
      selectedValue == -2 ? null : selectedValue
    );
  };

  const handleDoctorChange = (event) => {
    const selectedValue = event.target.value;

    // Si selecciona "No Doctor" (-2), filtrar los que no tienen doctor (doctor_id = null)
    setSelectedDoctor(selectedValue == -1 ? "" : selectedValue);

    handleFilterChange("doctor_id", selectedValue == -2 ? null : selectedValue);
  };

  const handleBuildingChange = (event) => {
    const selectedValue = event.target.value;

    // Si selecciona "No Building" (-2), filtrar los que no tienen edificio (building_id = null)
    setSelectedBuilding(selectedValue == -1 ? "" : selectedValue);

    handleFilterChange(
      "building_id",
      selectedValue == -2 ? null : selectedValue
    );
  };

  return (
    <div style={{ height: 700 }}>
      <div
        style={{
          padding: 5,
          borderBottom: "1px solid #e4e0e0",
          margin: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Iconify
          icon={"bi:file-earmark-image"}
          style={{
            margin: 5,
            width: 44,
            height: 44,
            color: "rgb(68 117 255)",
          }}
        />
        <Typography style={{ fontWeight: 100, fontSize: 16.3, width: "100%" }}>
          {" "}
          {category.title.toUpperCase()}
        </Typography>

        <div style={{ width: "100%", textAlign: "right" }}>
          <TextField
            style={{ maxWidth: "45%" }}
            onChange={(value) => {
              console.log("FILTERS ANTES: ", filters);
              !isLoading
                ? debouncedSearch(value.target.value)
                : onSearchChange(value.target.value);
            }}
            InputProps={{
              endAdornment: <SearchIcon style={{ color: "rgb(68 117 255)" }} />,
            }}
            label=" Search..."
          />
        </div>
        {category.id == 5 && (
          <IconButton
            style={{
              maxHeight: 45,
              maxWidth: 45,
              marginLeft: 13,
              backgroundColor: "rgb(68 117 255)",
            }}
            aria-label="Add Template"
            onClick={() => {
              openMyTemplatesForm(null);
            }}
          >
            <AddIcon style={{ color: "white" }} />
          </IconButton>
        )}
      </div>

      <>
        <div style={{ display: "flex", height: 485 }}>
          {/* <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
            anchor="left"
          >
            <ScrollBar>
              <Typography
                style={{ color: "gray", fontWeight: 100, fontSize: 15 }}
              >
                Folders
              </Typography>
              <List>
                <Button
                  onClick={() => {
                    setFilters({ filters: {} });
                    filtersApplied.current = { filters: {} };
                    getSMSMMSTemplatesByCategory(category.id, {
                      filters: {},
                      name: searchValue,
                    });
                  }}
                  style={{
                    width: "100%",
                    justifyContent: "left",
                    backgroundColor:
                      JSON.stringify(filters.filters) == JSON.stringify({})
                        ? "rgb(236 240 243)"
                        : "",
                  }}
                >
                  <Iconify
                    style={{
                      width: 23,
                      height: 23,
                      marginLeft: 4,
                      color: "#465971",
                    }}
                    icon={"codicon:list-flat"}
                  />
                  <p style={{ fontSize: 16, fontWeight: 100, margin: 3 }}>
                    All Templates
                  </p>
                </Button>

                <Accordion expanded={expandedControl.building == -1} square>
                  <AccordionSummary
                    onClick={() => {
                      setExpandedControl({
                        ...expandedControl,
                        ...{
                          building: expandedControl.building == -1 ? null : -1,
                        },
                      });

                      var filter = {


                        building_id: null


                      };

                      setFilters({
                        ...filters,
                        ...{ filters: filter },
                      });
                      filtersApplied.current = {
                        ...filters,
                        ...{ filters: filter },
                      };
                      getSMSMMSTemplatesByCategory(
                        category.id,
                        {
                          ...filters,
                          ...{ filters: filter },
                        }
                      );
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Iconify
                        style={{
                          height: 17,
                          width: 17,
                          margin: 6,
                          color: "#b4c3d4",
                        }}
                        icon={"entypo:folder"}
                      />
                      <Typography
                        style={{
                          fontWeight: 100,
                          fontSize: 14.5,
                          color: "#2f2f2f",
                        }}
                      >
                        No Building
                      </Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    {expandedControl.building == -1 ? (
                      <List>
                        <Accordion
                          square
                          expanded={
                            expandedControl.dr == -1 &&
                            expandedControl.building == -1
                          }
                        >
                          <AccordionSummary
                            onClick={() => {
                              setExpandedControl({
                                ...expandedControl,
                                ...{ dr: expandedControl.dr == -1 ? null : -1 },
                              });

                              var filter = {


                                building_id: expandedControl.building,
                                doctor_id: null


                              };

                              setFilters({
                                ...filters,
                                ...{ filters: filter },
                              });
                              filtersApplied.current = {
                                ...filters,
                                ...{ filters: filter },
                              };
                              getSMSMMSTemplatesByCategory(
                                category.id,
                                {
                                  ...filters,
                                  ...{ filters: filter },
                                }
                              );

                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Iconify
                                style={{
                                  height: 17,
                                  width: 17,
                                  margin: 6,
                                  color: "#b4c3d4",
                                }}
                                icon={"entypo:folder"}
                              />
                              <Typography
                                style={{
                                  fontWeight: 100,
                                  fontSize: 14.5,
                                  color: "#2f2f2f",
                                }}
                              >
                                No Doctor
                              </Typography>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            {expandedControl.dr == -1 &&
                              expandedControl.building == -1 ? (
                              <List>
                                <Button
                                  onClick={() => {
                                    var filter = {
                                      ...filters?.filters,
                                      ...{
                                        building_id: null,
                                        doctor_id: null,
                                        procedure_id: null,
                                      },
                                    };

                                    setFilters({
                                      ...filters,
                                      ...{ filters: filter },
                                    });
                                    filtersApplied.current = {
                                      ...filters,
                                      ...{ filters: filter },
                                    };
                                    getSMSMMSTemplatesByCategory(category.id, {
                                      ...filters,
                                      ...{ filters: filter },
                                    });
                                  }}
                                  style={{
                                    justifyContent: "left",
                                    width: "100%",
                                    textAlign: "left",
                                    backgroundColor:
                                      JSON.stringify(filters.filters) !=
                                        JSON.stringify({}) &&
                                        filters.filters.building_id == null &&
                                        filters.filters.doctor_id == null &&
                                        filters.filters.procedure_id == null
                                        ? "rgb(236 240 243)"
                                        : "",
                                  }}
                                >
                                  <Typography
                                    style={{
                                      fontWeight: 100,
                                      fontSize: 14.5,
                                      color: "#2f2f2f",
                                    }}
                                  >
                                    No Procedure
                                  </Typography>
                                </Button>

                                {procedureOptions().map((procedure) => {
                                  return (
                                    <Button
                                      onClick={() => {
                                        var filter = {
                                          ...filters?.filters,
                                          ...{
                                            building_id: null,
                                            doctor_id: null,
                                            procedure_id: procedure.id,
                                          },
                                        };

                                        setFilters({
                                          ...filters,
                                          ...{ filters: filter },
                                        });
                                        filtersApplied.current = {
                                          ...filters,
                                          ...{ filters: filter },
                                        };
                                        getSMSMMSTemplatesByCategory(
                                          category.id,
                                          {
                                            ...filters,
                                            ...{ filters: filter },
                                          }
                                        );
                                      }}
                                      style={{
                                        justifyContent: "left",
                                        width: "100%",
                                        textAlign: "left",
                                        backgroundColor:
                                          filters.filters.building_id == null &&
                                            filters.filters.doctor_id == null &&
                                            filters.filters.procedure_id ==
                                            procedure.id
                                            ? "rgb(236 240 243)"
                                            : "",
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          fontWeight: 100,
                                          fontSize: 14.5,
                                          color: "#2f2f2f",
                                        }}
                                      >
                                        {procedure.title}
                                      </Typography>
                                    </Button>
                                  );
                                })}
                              </List>
                            ) : (
                              ""
                            )}
                          </AccordionDetails>
                        </Accordion>
                        {doctors?.map((doctor) => {
                          return (
                            <Accordion
                              square
                              expanded={
                                expandedControl.dr == doctor.id &&
                                expandedControl.building == -1
                              }
                            >
                              <AccordionSummary onClick={() => {
                                setExpandedControl({
                                  ...expandedControl,
                                  ...{
                                    dr:
                                      expandedControl.dr == doctor.id
                                        ? null
                                        : doctor.id,
                                  },
                                });

                                var filter = {
                                  building_id: null,
                                  doctor_id: doctor.id
                                };

                                setFilters({
                                  ...filters,
                                  ...{ filters: filter },
                                });
                                filtersApplied.current = {
                                  ...filters,
                                  ...{ filters: filter },
                                };
                                getSMSMMSTemplatesByCategory(
                                  category.id,
                                  {
                                    ...filters,
                                    ...{ filters: filter },
                                  }
                                );
                              }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Iconify
                                    style={{
                                      height: 17,
                                      width: 17,
                                      margin: 6,
                                      color: "#b4c3d4",
                                    }}
                                    icon={"entypo:folder"}
                                  />
                                  <Typography
                                    style={{
                                      fontWeight: 100,
                                      fontSize: 14.5,
                                      color: "#2f2f2f",
                                    }}
                                  >
                                    {doctor.fullname}
                                  </Typography>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                {expandedControl.dr == doctor.id &&
                                  expandedControl.building == -1 ? (
                                  <List>
                                    <Button
                                      style={{
                                        justifyContent: "left",
                                        width: "100%",
                                        textAlign: "left",
                                        backgroundColor:
                                          JSON.stringify(filters.filters) !=
                                            JSON.stringify({}) &&
                                            filters.filters.building_id == null &&
                                            filters.filters.doctor_id ==
                                            doctor.id &&
                                            filters.filters.procedure_id == null
                                            ? "rgb(236 240 243)"
                                            : "",
                                      }}
                                      onClick={() => {
                                        var filter = {
                                          ...filters?.filters,
                                          ...{
                                            building_id: null,
                                            doctor_id: doctor.id,
                                            procedure_id: null,
                                          },
                                        };

                                        setFilters({
                                          ...filters,
                                          ...{ filters: filter },
                                        });
                                        filtersApplied.current = {
                                          ...filters,
                                          ...{ filters: filter },
                                        };
                                        getSMSMMSTemplatesByCategory(
                                          category.id,
                                          {
                                            ...filters,
                                            ...{ filters: filter },
                                          }
                                        );
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          fontWeight: 100,
                                          fontSize: 14.5,
                                          color: "#2f2f2f",
                                        }}
                                      >
                                        No Procedure
                                      </Typography>
                                    </Button>
                                    {procedureOptions().map((procedure) => {
                                      return (
                                        <Button
                                          onClick={() => {
                                            var filter = {
                                              ...filters?.filters,
                                              ...{
                                                building_id: null,
                                                doctor_id: doctor.id,
                                                procedure_id: procedure.id,
                                              },
                                            };

                                            setFilters({
                                              ...filters,
                                              ...{ filters: filter },
                                            });
                                            filtersApplied.current = {
                                              ...filters,
                                              ...{ filters: filter },
                                            };
                                            getSMSMMSTemplatesByCategory(
                                              category.id,
                                              {
                                                ...filters,
                                                ...{ filters: filter },
                                              }
                                            );
                                          }}
                                          style={{
                                            justifyContent: "left",
                                            width: "100%",
                                            textAlign: "left",
                                            backgroundColor:
                                              JSON.stringify(filters.filters) !=
                                                JSON.stringify({}) &&
                                                filters.filters.building_id ==
                                                null &&
                                                filters.filters.doctor_id ==
                                                doctor.id &&
                                                filters.filters.procedure_id ==
                                                procedure.id
                                                ? "rgb(236 240 243)"
                                                : "",
                                          }}
                                        >
                                          <Typography
                                            style={{
                                              fontWeight: 100,
                                              fontSize: 14.5,
                                              color: "#2f2f2f",
                                            }}
                                          >
                                            {procedure.title}
                                          </Typography>
                                        </Button>
                                      );
                                    })}
                                  </List>
                                ) : (
                                  ""
                                )}
                              </AccordionDetails>
                            </Accordion>
                          );
                        })}
                      </List>
                    ) : (
                      ""
                    )}
                  </AccordionDetails>
                </Accordion>

                {buildings?.map((building, index) => (
                  <Accordion
                    square
                    expanded={expandedControl.building == building.id}
                  >
                    <AccordionSummary
                      onClick={() => {
                        setExpandedControl({
                          ...expandedControl,
                          ...{
                            building:
                              expandedControl.building == building.id
                                ? null
                                : building.id,
                          },


                        });

                        var filter = {


                          building_id: building.id


                        };

                        setFilters({
                          ...filters,
                          ...{ filters: filter },
                        });
                        filtersApplied.current = {
                          ...filters,
                          ...{ filters: filter },
                        };
                        getSMSMMSTemplatesByCategory(
                          category.id,
                          {
                            ...filters,
                            ...{ filters: filter },
                          }
                        );
                      }}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Iconify
                          style={{
                            height: 17,
                            width: 17,
                            margin: 6,
                            color: "#b4c3d4",
                          }}
                          icon={"entypo:folder"}
                        />
                        <Typography
                          style={{
                            fontWeight: 100,
                            fontSize: 14.5,
                            color: "#2f2f2f",
                          }}
                        >
                          {building.name}
                        </Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {expandedControl.building == building.id ? (
                        <List>
                          <Accordion
                            square
                            expanded={
                              expandedControl.building == building.id &&
                              expandedControl.dr == -1
                            }
                          >
                            <AccordionSummary
                              onClick={() => {
                                setExpandedControl({
                                  ...expandedControl,
                                  ...{
                                    dr: expandedControl.dr == -1 ? null : -1,
                                  },
                                });

                                var filter = {


                                  building_id: expandedControl.building,
                                  doctor_id: null


                                };

                                setFilters({
                                  ...filters,
                                  ...{ filters: filter },
                                });
                                filtersApplied.current = {
                                  ...filters,
                                  ...{ filters: filter },
                                };
                                getSMSMMSTemplatesByCategory(
                                  category.id,
                                  {
                                    ...filters,
                                    ...{ filters: filter },
                                  }
                                );
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Iconify
                                  style={{
                                    height: 17,
                                    width: 17,
                                    margin: 6,
                                    color: "#b4c3d4",
                                  }}
                                  icon={"entypo:folder"}
                                />
                                <Typography
                                  style={{
                                    fontWeight: 100,
                                    fontSize: 14.5,
                                    color: "#2f2f2f",
                                  }}
                                >
                                  No Doctor
                                </Typography>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              {expandedControl.building == building.id &&
                                expandedControl.dr == -1 ? (
                                <List>
                                  <Button
                                    onClick={() => {
                                      var filter = {
                                        ...filters?.filters,
                                        ...{
                                          building_id: building.id,
                                          doctor_id: null,
                                          procedure_id: null,
                                        },
                                      };

                                      setFilters({
                                        ...filters,
                                        ...{ filters: filter },
                                      });
                                      filtersApplied.current = {
                                        ...filters,
                                        ...{ filters: filter },
                                      };
                                      getSMSMMSTemplatesByCategory(
                                        category.id,
                                        {
                                          ...filters,
                                          ...{ filters: filter },
                                        }
                                      );
                                    }}
                                    style={{
                                      justifyContent: "left",
                                      width: "100%",
                                      textAlign: "left",
                                      backgroundColor:
                                        JSON.stringify(filters.filters) !=
                                          JSON.stringify({}) &&
                                          filters.filters.building_id ==
                                          building.id &&
                                          filters.filters.doctor_id == null &&
                                          filters.filters.procedure_id == null
                                          ? "rgb(236 240 243)"
                                          : "",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        fontWeight: 100,
                                        fontSize: 14.5,
                                        color: "#2f2f2f",
                                      }}
                                    >
                                      No Procedure
                                    </Typography>
                                  </Button>

                                  {procedureOptions().map((procedure) => {
                                    return (
                                      <Button
                                        onClick={() => {
                                          var filter = {
                                            ...filters?.filters,
                                            ...{
                                              building_id: building.id,
                                              doctor_id: null,
                                              procedure_id: procedure.id,
                                            },
                                          };

                                          setFilters({
                                            ...filters,
                                            ...{ filters: filter },
                                          });
                                          filtersApplied.current = {
                                            ...filters,
                                            ...{ filters: filter },
                                          };
                                          getSMSMMSTemplatesByCategory(
                                            category.id,
                                            {
                                              ...filters,
                                              ...{ filters: filter },
                                            }
                                          );
                                        }}
                                        style={{
                                          justifyContent: "left",
                                          width: "100%",
                                          textAlign: "left",
                                          backgroundColor:
                                            JSON.stringify(filters.filters) !=
                                              JSON.stringify({}) &&
                                              filters.filters.building_id ==
                                              building.id &&
                                              filters.filters.doctor_id == null &&
                                              filters.filters.procedure_id ==
                                              procedure.id
                                              ? "rgb(236 240 243)"
                                              : "",
                                        }}
                                      >
                                        <Typography
                                          style={{
                                            fontWeight: 100,
                                            fontSize: 14.5,
                                            color: "#2f2f2f",
                                          }}
                                        >
                                          {procedure.title}
                                        </Typography>
                                      </Button>
                                    );
                                  })}
                                </List>
                              ) : (
                                ""
                              )}
                            </AccordionDetails>
                          </Accordion>
                          {building?.doctors?.data?.map((doctor) => {
                            return (
                              <Accordion
                                square
                                expanded={
                                  expandedControl.building == building.id &&
                                  expandedControl.dr == doctor.id
                                }
                              >
                                <AccordionSummary
                                  onClick={() => {
                                    setExpandedControl({
                                      ...expandedControl,
                                      ...{
                                        dr:
                                          expandedControl.dr == doctor.id
                                            ? null
                                            : doctor.id,
                                      },
                                    });

                                    var filter = {
                                      building_id: expandedControl.building,
                                      doctor_id: doctor.id
                                    };

                                    setFilters({
                                      ...filters,
                                      ...{ filters: filter },
                                    });
                                    filtersApplied.current = {
                                      ...filters,
                                      ...{ filters: filter },
                                    };
                                    getSMSMMSTemplatesByCategory(
                                      category.id,
                                      {
                                        ...filters,
                                        ...{ filters: filter },
                                      }
                                    );
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Iconify
                                      style={{
                                        height: 17,
                                        width: 17,
                                        margin: 6,
                                        color: "#b4c3d4",
                                      }}
                                      icon={"entypo:folder"}
                                    />
                                    <Typography
                                      style={{
                                        fontWeight: 100,
                                        fontSize: 14.5,
                                        color: "#2f2f2f",
                                      }}
                                    >
                                      {doctor.users_fname}
                                    </Typography>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  {expandedControl.building == building.id &&
                                    expandedControl.dr == doctor.id ? (
                                    <List>
                                      <Button
                                        onClick={() => {
                                          var filter = {
                                            ...filters?.filters,
                                            ...{
                                              building_id: building.id,
                                              doctor_id: doctor.id,
                                              procedure_id: null,
                                            },
                                          };

                                          setFilters({
                                            ...filters,
                                            ...{ filters: filter },
                                          });
                                          filtersApplied.current = {
                                            ...filters,
                                            ...{ filters: filter },
                                          };
                                          getSMSMMSTemplatesByCategory(
                                            category.id,
                                            {
                                              ...filters,
                                              ...{ filters: filter },
                                            }
                                          );
                                        }}
                                        style={{
                                          justifyContent: "left",
                                          width: "100%",
                                          textAlign: "left",
                                          backgroundColor:
                                            JSON.stringify(filters.filters) !=
                                              JSON.stringify({}) &&
                                              filters.filters.building_id ==
                                              building.id &&
                                              filters.filters.doctor_id ==
                                              doctor.id &&
                                              filters.filters.procedure_id == null
                                              ? "rgb(236 240 243)"
                                              : "",
                                        }}
                                      >
                                        <Typography
                                          style={{
                                            fontWeight: 100,
                                            fontSize: 14.5,
                                            color: "#2f2f2f",
                                          }}
                                        >
                                          No Procedure
                                        </Typography>
                                      </Button>

                                      {procedureOptions().map((procedure) => {
                                        return (
                                          <Button
                                            onClick={() => {
                                              var filter = {
                                                ...filters?.filters,
                                                ...{
                                                  building_id: building.id,
                                                  doctor_id: doctor.id,
                                                  procedure_id: procedure.id,
                                                },
                                              };

                                              setFilters({
                                                ...filters,
                                                ...{ filters: filter },
                                              });
                                              filtersApplied.current = {
                                                ...filters,
                                                ...{ filters: filter },
                                              };
                                              getSMSMMSTemplatesByCategory(
                                                category.id,
                                                {
                                                  ...filters,
                                                  ...{ filters: filter },
                                                }
                                              );
                                            }}
                                            style={{
                                              justifyContent: "left",
                                              width: "100%",
                                              textAlign: "left",
                                              backgroundColor:
                                                JSON.stringify(
                                                  filters.filters
                                                ) != JSON.stringify({}) &&
                                                  filters.filters.building_id ==
                                                  building.id &&
                                                  filters.filters.doctor_id ==
                                                  doctor.id &&
                                                  filters.filters.procedure_id ==
                                                  procedure.id
                                                  ? "rgb(236 240 243)"
                                                  : "",
                                            }}
                                          >
                                            <Typography
                                              style={{
                                                fontWeight: 100,
                                                fontSize: 14.5,
                                                color: "#2f2f2f",
                                              }}
                                            >
                                              {procedure.title}
                                            </Typography>
                                          </Button>
                                        );
                                      })}
                                    </List>
                                  ) : (
                                    ""
                                  )}
                                </AccordionDetails>
                              </Accordion>
                            );
                          })}
                        </List>
                      ) : (
                        ""
                      )}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </List>
            </ScrollBar>
          </Drawer> */}

          <div style={{ width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              {/* Reset Filters Button */}
              <Tooltip title="Reset filters" placement="top">
                <Button
                  onClick={() => {
                    // Reset filters
                    setFilters({ filters: {} });
                    filtersApplied.current = { filters: {} };
                    getSMSMMSTemplatesByCategory(category.id, {
                      filters: {},
                      name: searchValue,
                    });

                    // Reset filters
                    setSelectedDoctor("");
                    setSelectedProcedure("");
                    setSelectedBuilding("");
                  }}
                  style={{
                    minWidth: 40,
                    height: 40,
                    padding: 0,
                    marginTop: 10,
                  }}
                >
                  <Iconify
                    style={{
                      width: 23,
                      height: 23,
                      color: "#465971",
                    }}
                    icon={"ic:outline-filter-list-off"}
                  />
                </Button>
              </Tooltip>

              {/* Dropdown Building */}
              <FormControl style={{ minWidth: 150 }}>
                <InputLabel>Building</InputLabel>
                <Select
                  value={selectedBuilding}
                  onChange={handleBuildingChange}
                  displayEmpty
                >
                  <MenuItem value="-1">
                    <em>---</em>
                  </MenuItem>
                  <MenuItem value="-2">
                    <em>No Building</em>
                  </MenuItem>
                  {buildings.map((building) => (
                    <MenuItem key={building.id} value={building.id}>
                      {building.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Dropdown Doctor */}
              <FormControl style={{ minWidth: 150 }}>
                <InputLabel>Doctor</InputLabel>
                <Select
                  value={selectedDoctor}
                  onChange={handleDoctorChange}
                  displayEmpty
                >
                  <MenuItem value="-1">
                    <em>---</em>
                  </MenuItem>
                  <MenuItem value="-2">
                    <em>No Doctor</em>
                  </MenuItem>
                  {doctors.map((doctor) => (
                    <MenuItem key={doctor.id} value={doctor.id}>
                      {doctor.fullname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Dropdown Procedure */}
              <FormControl style={{ minWidth: 150 }}>
                <InputLabel>Procedure</InputLabel>
                <Select
                  value={selectedProcedure}
                  onChange={handleProcedureChange}
                  displayEmpty
                >
                  <MenuItem disableRipple value="-3">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          onChange={(event) => {
                            event.stopPropagation(); // Detener propagación del evento click
                            handleCheckboxChange(event);
                          }}
                        />
                      }
                      label="Show Inactive Procedures"
                      onClick={(event) => event.stopPropagation()} // Evitar que se cierre el dropdown al hacer clic en el Checkbox
                    />
                  </MenuItem>
                  <MenuItem value="-1">
                    <em>---</em>
                  </MenuItem>
                  <MenuItem value="-2">
                    <em>No Procedure</em>
                  </MenuItem>
                  {procedureOptions().map((procedure) => (
                    <MenuItem key={procedure.id} value={procedure.id}>
                      {procedure.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "8px",
                marginTop: "20px",
              }}
            >
              <Button
                style={{ width: "35%", justifyContent: "left" }}
                onClick={() => {
                  setIsSelectedAll(!isSelectedAll);
                  if (!isSelectedAll == true) {
                    setSelectedTemplates(templates);
                  } else {
                    setSelectedTemplates([]);
                  }
                }}
              >
                {templates &&
                selectedTemplates &&
                templates.length > 0 &&
                templates.length == selectedTemplates.length
                  ? "Unselect All"
                  : "Select All"}
              </Button>

              {selectedTemplates.length > 0 && (
                <Typography
                  style={{ width: "100%" }}
                >{`(${selectedTemplates.length} Selected)`}</Typography>
              )}

              {category.id == 5 && (
                <div style={{ width: "100%", textAlign: "right" }}>
                  <Button
                    style={{ color: "#646464", whiteSpace: "pre" }}
                    onClick={() => {
                      setEditMode(!editMode);
                      setSelectedTemplates([]);
                    }}
                  >
                    {editMode ? (
                      <CloseIcon
                        style={{ height: 17, margin: 3, color: "#d35c3f" }}
                      />
                    ) : (
                      <EditIcon
                        style={{ height: 17, margin: 3, color: "#9ba3e4" }}
                      />
                    )}{" "}
                    {editMode ? "Exit Edit Mode" : "Edit Mode"}
                  </Button>
                </div>
              )}
            </div>

            {templates && templates.length > 0 && !isLoading ? (
              <>
                <ScrollBar style={{ maxHeight: 360 }}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "left",
                    }}
                  >
                    {templates
                      .filter((t) => (!editMode ? t.is_active == 1 : true))
                      .map((a) => {
                        return (
                          <Card
                            style={{
                              textAlign: "center",
                              margin: 5,
                              backgroundColor: "#fdfeff",
                              borderStyle: "solid",
                              borderWidth: "1px",
                              borderColor: "rgb(238 238 238)",
                              borderRadius: 4,
                              width: 150,
                              alignSelf: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                backgroundColor: !a.is_active
                                  ? "rgb(235 235 235)"
                                  : editMode
                                  ? "#f2f6f9"
                                  : "#f6f9fc",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              {!a.is_active && (
                                <div style={{ display: "flex" }}>
                                  <Typography
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 500,
                                      color: "gray",
                                      marginTop: 3,
                                    }}
                                  >
                                    {`Inactive`}
                                  </Typography>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  justifyContent: editMode
                                    ? "right"
                                    : "space-between",
                                }}
                              >
                                {category.id == 5 && editMode && (
                                  <>
                                    <IconButton
                                      style={{ maxHeight: 10, maxWidth: 10 }}
                                    >
                                      <EditIcon
                                        onClick={() => {
                                          openMyTemplatesForm(a);
                                        }}
                                        style={{
                                          maxHeight: 18,
                                          color: "#2852b6",
                                        }}
                                      />
                                    </IconButton>
                                    <IconButton
                                      style={{ maxHeight: 10, maxWidth: 10 }}
                                      onClick={() => {
                                        onClickDelete(a.id);
                                      }}
                                    >
                                      <DeleteIcon
                                        style={{
                                          maxHeight: 18,
                                          color: "#d35c3f",
                                        }}
                                      />
                                    </IconButton>
                                  </>
                                )}

                                {!editMode && (
                                  <div
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div>
                                      {a.shared_by_user ? (
                                        <Typography
                                          style={{
                                            paddingRight: "5px",
                                            fontSize: 11,
                                            marginTop: 3,
                                            color: "#4a5c7d",
                                          }}
                                        >
                                          {`Shared by ${a.shared_by_user}`}
                                        </Typography>
                                      ) : (
                                        ""
                                      )}
                                    </div>

                                    <div>
                                      <Checkbox
                                        size="small"
                                        checked={
                                          selectedTemplates.findIndex(
                                            (f) => f.id == a.id
                                          ) != -1
                                        }
                                        style={{ margin: -9 }}
                                        onChange={() => {
                                          onChangeCheckBox(a);
                                        }}
                                        color="primary"
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <CardActionArea
                              style={{ width: 135, height: 128 }}
                              onClick={() => {
                                setTemplateSelected(a);
                              }}
                            >
                              {a.type_of_message == "mms" &&
                              a.media_type != "video/mp4" ? (
                                <img
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                  }}
                                  src={a.tempUrl}
                                />
                              ) : a.type_of_message == "mms" &&
                                a.media_type == "video/mp4" ? (
                                <video
                                  style={{
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                  }}
                                  controls
                                >
                                  <source
                                    src={a.tempUrl}
                                    type="video/mp4"
                                  ></source>
                                </video>
                              ) : (
                                <ScrollBar style={{ maxHeight: "100%" }}>
                                  <Typography
                                    style={{
                                      maxHeight: "100%",
                                      fontSize: 10,
                                      textAlign: "justify",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {a?.body || a?.body_es || ""}
                                  </Typography>
                                </ScrollBar>
                              )}
                            </CardActionArea>

                            <div
                              style={{
                                backgroundColor: "rgb(238 238 238)",
                                color: "#6a6a6a",
                              }}
                            >
                              <Typography>{a.name}</Typography>
                            </div>
                          </Card>
                        );
                      })}
                  </div>
                </ScrollBar>

                {selectedTemplates.length > 0 && (
                  <div style={{ display: "flex", justifyContent: "right" }}>
                    {category.id == 5 ? (
                      <Button
                        style={{ float: "right", fontSize: 17 }}
                        onClick={() => {
                          setIsOpenSharePopup(true);
                        }}
                        startIcon={
                          <Iconify
                            icon="solar:share-bold"
                            style={{ color: blue[700], width: 23, height: 23 }}
                          />
                        }
                      >
                        Share
                      </Button>
                    ) : (
                      ""
                    )}

                    <Button
                      style={{ float: "right", fontSize: 17 }}
                      onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                      }}
                      startIcon={
                        <Iconify
                          icon="fluent:send-20-filled"
                          style={{ color: blue[700], width: 23, height: 23 }}
                        />
                      }
                    >
                      Send
                    </Button>
                  </div>
                )}
              </>
            ) : isLoading ? (
              <div style={{ margin: 20, width: "94%", textAlign: "center" }}>
                <CircularProgress disableShrink />
              </div>
            ) : (
              <Typography
                style={{
                  padding: 16,
                  fontSize: 16,
                  textAlign: "center",
                  color: "#3f3f3f",
                }}
              >
                No templates to display
              </Typography>
            )}
          </div>
        </div>

        <Menu
          classes={{ paper: classes.menu }}
          style={{ marginTop: 2 }}
          id="more-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <MenuItem
            onClick={(event) => {
              sendTemplates("en").then(() => {
                setIsOpenDialogTemplates(false);
                setTemplateSelected(null);
                handleClose();
              });
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Iconify
              style={{
                fontSize: 20,
                margin: 4,
              }}
              icon={"emojione:flag-for-united-states"}
            />
            Send in English
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              sendTemplates("es").then(() => {
                setIsOpenDialogTemplates(false);
                setTemplateSelected(null);
                handleClose();
              });
            }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Iconify
              style={{
                fontSize: 20,
                margin: 4,
              }}
              icon={"emojione:flag-for-spain"}
            />
            Send in Spanish
          </MenuItem>
        </Menu>

        <Popup
          className={true}
          title={templateSelected?.name}
          openPopup={templateSelected}
          onClose={closeTemplate}
        >
          <div>
            {" "}
            <br />
            <Card
              style={{
                textAlign: "center",
                textAlign: "center",
                maxWidth: "fit-content",
                minWidth: "60%",
                margin: "0 auto",
              }}
            >
              <CardContent>
                <AppBar
                  className={classes.appBarLanguages}
                  position="static"
                  color="default"
                >
                  <Tabs
                    value={selectedLanguage}
                    onChange={handleLanguageTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#3f667d",
                      },
                    }}
                  >
                    <Tab className={classes.tabStyle} label={"English"} />
                    <Tab className={classes.tabStyle} label={"Spanish"} />
                  </Tabs>
                </AppBar>

                <TabPanel
                  st={{ backgroundColor: "white", padding: 8 }}
                  value={selectedLanguage}
                  index={0}
                >
                  <ScrollBar style={{ maxHeight: "580px" }}>
                    {templateSelected &&
                    templateSelected.tempUrl &&
                    templateSelected.type_of_message == "mms" ? (
                      templateSelected.media_type != "video/mp4" ? (
                        <>
                          <img
                            style={{ maxHeight: "340px" }}
                            src={templateSelected?.tempUrl}
                          />
                          {templateSelected?.body && (
                            <div
                              style={{
                                padding: 9,
                                margin: 18,
                              }}
                            >
                              <Typography
                                style={{ textAlign: "justify", fontSize: 15 }}
                              >
                                {templateSelected?.body || ""}
                              </Typography>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <video
                            style={{ maxHeight: "100%", maxWidth: "100%" }}
                            controls
                          >
                            <source
                              src={templateSelected?.tempUrl}
                              type="video/mp4"
                            ></source>
                          </video>
                          {templateSelected?.body && (
                            <div
                              style={{
                                padding: 9,
                                margin: 18,
                              }}
                            >
                              <Typography
                                style={{ textAlign: "justify", fontSize: 15 }}
                              >
                                {templateSelected?.body || ""}
                              </Typography>
                            </div>
                          )}
                        </>
                      )
                    ) : templateSelected && templateSelected.body ? (
                      <div
                        style={{
                          padding: 9,
                          margin: 18,
                        }}
                      >
                        <Typography
                          style={{ textAlign: "justify", fontSize: 15 }}
                        >
                          {templateSelected?.body || ""}
                        </Typography>
                      </div>
                    ) : (
                      <Typography
                        style={{
                          textAlign: "center",
                          fontSize: 15,
                          marginTop: 5,
                        }}
                      >
                        There is no template configured in English
                      </Typography>
                    )}
                  </ScrollBar>
                </TabPanel>
                <TabPanel
                  st={{ backgroundColor: "white", padding: 8 }}
                  value={selectedLanguage}
                  index={1}
                >
                  <ScrollBar style={{ maxHeight: "580px" }}>
                    {templateSelected &&
                    templateSelected.tempUrl &&
                    templateSelected.type_of_message == "mms" ? (
                      templateSelected.media_type != "video/mp4" ? (
                        <>
                          <img
                            style={{ maxHeight: "340px" }}
                            src={templateSelected?.tempUrl}
                          />
                          {templateSelected?.body_es && (
                            <div
                              style={{
                                padding: 9,
                                margin: 18,
                              }}
                            >
                              <Typography
                                style={{ textAlign: "justify", fontSize: 15 }}
                              >
                                {templateSelected?.body_es || ""}
                              </Typography>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <video
                            style={{ maxHeight: "100%", maxWidth: "100%" }}
                            controls
                          >
                            <source
                              src={templateSelected?.tempUrl}
                              type="video/mp4"
                            ></source>
                          </video>
                          {templateSelected?.body_es && (
                            <div
                              style={{
                                padding: 9,
                                margin: 18,
                              }}
                            >
                              <Typography
                                style={{ textAlign: "justify", fontSize: 15 }}
                              >
                                {templateSelected?.body_es || ""}
                              </Typography>
                            </div>
                          )}
                        </>
                      )
                    ) : templateSelected && templateSelected.body_es ? (
                      <div
                        style={{
                          padding: 9,
                          margin: 18,
                        }}
                      >
                        <Typography
                          style={{ textAlign: "justify", fontSize: 15 }}
                        >
                          {templateSelected?.body_es || ""}
                        </Typography>
                      </div>
                    ) : (
                      <Typography
                        style={{
                          textAlign: "center",
                          fontSize: 15,
                          marginTop: 5,
                        }}
                      >
                        There is no template configured in Spanish
                      </Typography>
                    )}
                  </ScrollBar>
                </TabPanel>
              </CardContent>
            </Card>
            <div
              style={{
                marginTop: 18,
                borderRadius: 14,
                background: "#e2e7eb57",
                padding: 13,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Iconify
                  style={{
                    color: "#516da3",
                    width: 19,
                    height: 19,
                    marginRight: 3,
                  }}
                  icon="tabler:template"
                />
                <Typography style={{ fontWeight: 600, fontSize: 17 }}>
                  Template Details
                </Typography>
              </div>
              <Divider style={{ marginBottom: 8, marginTop: 5 }} />
              <div
                style={{ display: "flex", alignItems: "top", flexWrap: "wrap" }}
              >
                <div className={classes.detailContainer}>
                  <Typography className={classes.detailTitle}>
                    {"Building: "}
                  </Typography>
                  <Typography className={classes.detailText}>
                    {templateSelected?.building?.data?.name}
                  </Typography>
                </div>
                <div className={classes.detailContainer}>
                  <Typography className={classes.detailTitle}>
                    {"Dr: "}
                  </Typography>
                  <Typography className={classes.detailText}>
                    {templateSelected?.doctor?.data?.users_fname}
                  </Typography>
                </div>
                <div className={classes.detailContainer}>
                  <Typography className={classes.detailTitle}>
                    {"Procedure: "}
                  </Typography>
                  <Typography className={classes.detailText}>
                    {templateSelected?.procedure?.data?.name}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      </>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
        confirmLoading={confirmDialogLoading}
      />
      <Popup
        fullWidth={true}
        title={"Template"}
        openPopup={popupMyTemplatesForm}
        onClose={closeMyTemplatesForm}
      >
        <MyTemplatesForm
          closeMyTemplatesForm={closeMyTemplatesForm}
          authUser={authUser}
          templateForEdit={templateForEdit}
          setTemplateForEdit={setTemplateForEdit}
          templates={templates}
          setTemplates={setTemplates}
        />
      </Popup>

      <Popup
        fullWidth={true}
        title={"Share selected templates"}
        openPopup={isOpenSharePopup}
        onClose={() => {
          setIsOpenSharePopup(false);
        }}
        maxWidth="sm"
      >
        <div style={{ display: "flex" }}>
          <Controls.Select
            label={"Share to"}
            allowEmpty={true}
            options={shareToOptions()}
            onChange={(el) => setShareTo(el.target.value)}
            value={shareTo}
          />

          <Button
            disabled={isSharing}
            style={{ marginLeft: 4 }}
            startIcon={<Iconify icon="ic:sharp-share" />}
            color="primary"
            onClick={shareTemplates}
            variant="contained"
          >
            {isSharing ? "Sharing..." : "Share"}
          </Button>
        </div>
      </Popup>
    </div>
  );
}
